import React from 'react';
import Bg from '../../images/backgrounds/cta_image.webp';
import { Link } from "react-router-dom";

const CtaSection = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <section className="calltoaction_section parallaxie" style={{ backgroundImage: `url(${Bg})` }}>
            <div className="container text-center">
                <div className="heading_block text-white">
                    <h2 className="heading_text">
                        Help mee aan een veiligere wereld bouwen
                    </h2>
                    <p className="heading_description mb-0">
                        Ontdek hoe Praeventor jouw organisatie kan beschermen tegen digitale dreigingen. Samen maken we cybersecurity toegankelijk en effectief voor iedereen."
                    </p>
                </div>
                <Link onClick={ClickHandler} to="/contact" className="btn btn-primary">
                    <span className="btn_label" data-text="Neem contact op en versterk je beveiliging!">Neem contact op en versterk je beveiliging!</span>
                    <span className="btn_icon">
                        <i className="fa-solid fa-arrow-up-right"></i>
                    </span>
                </Link>
            </div>
        </section>
    );
}

export default CtaSection;